import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { useParams } from "react-router-dom";

import { UPDATE_GIFT } from "actions/ActionTypes";
import history from "components/common/navigation/AppHistory";
import { putApi } from "actions/SendActions";

import { notifError } from "actions/FlashMessageActions";
import GiftAdminForm from "components/gift/GiftAdminForm";
import { PROJECTS_ROUTE } from "../routes/routes";

import "css/admin/smartlist.scss";

export function GiftAdminUpdateUI({
  onSubmit,
  onError,
  gifts,
  match,
  token,
  t,
}) {
  const { projectSlug } = useParams();
  if (!gifts || gifts.data.length === 0) {
    history.push(PROJECTS_ROUTE);
    return null;
  }

  let free_copy = null;
  const index = gifts.indexes.uuid[match.params.id];

  if (index) {
    const item = gifts.data[index[0]];
    free_copy = {
      uuid: item.uuid,
      email: item.email,
      month_duration: item.month_duration,
      code: item.code,
      limit_date: item.limit_date,
      offer_uuid: item.offer_plan.offer_uuid,
    };
  }

  const onUpdate = (item) => {
    // Format model for saving
    const { email, limit_date } = item;
    const data = { email, limit_date };

    const errorMessages = itemIsValide(data);
    if (errorMessages.length === 0) {
      onSubmit(item.uuid, data, token, projectSlug, t);
    } else {
      onError(t("editor-errors:saveGiftError"), errorMessages);
    }
  };

  const itemIsValide = (item) => {
    const errorMessages = [];

    if (!item.email) {
      errorMessages.push(t("editor-errors:emailNull"));
    }

    if (!item.limit_date) {
      errorMessages.push(t("editor-errors:limiteDateNull"));
    }

    if (item.limit_date && moment(item.limit_date).isBefore(moment())) {
      errorMessages.push(t("editor-errors:limiteMustBeInFuture"));
    }

    return errorMessages;
  };

  return <GiftAdminForm item={free_copy} onSubmit={onUpdate} editMode />;
}

GiftAdminUpdateUI.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  gifts: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { gifts } = state.fetchReducer;
  const { token } = state.loginReducer;

  return {
    gifts,
    token,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSubmit(uuid, data, token, projectSlug, t) {
    dispatch(
      putApi({
        endpoint: `/api/offer/v4/admin/gifts/${uuid}`,
        type: UPDATE_GIFT,
        headers: [
          {
            key: "xx-ok-project",
            value: projectSlug,
          },
        ],
        token,
        data,
        error: t("saveGiftError"),
        callback: () => {
          history.push(`${PROJECTS_ROUTE}/${projectSlug}/gift`);
        },
      }),
    );
  },
  onError(error, details) {
    dispatch(notifError(error, details));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("editor-gift", "editor-errors")(GiftAdminUpdateUI));
